"use client";

import { usePostHog } from "@posthog/next";
import { useEffect } from "react";
import { dropNoiseExceptions } from "@/utils/posthogNoise";

export default function PostHogNoiseFilter() {
  const posthog = usePostHog();

  useEffect(() => {
    posthog.set_config({ before_send: dropNoiseExceptions });
  }, [posthog]);

  return null;
}
